"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40 };
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-tabs/lib/KeyCode.js
 ** module id = 636
 ** module chunks = 0
 **/